module.exports = __webpack_public_path__ + "static/media/confirm.3a5b5576.svg";